module.exports = __webpack_public_path__ + "fd2a4c633b5391fe120066eca63890a4.png";